import { client } from '../..'
import { GENERATE_RANKING_REPORT, CREATE_ZIP_WITH_SELECTED_RANKING_REPORTS, GENERATE_TARGET_REPORT_REQUEST } from './Mutations'
import {
  GenerateRankingReportMutation,
  GenerateRankingReportMutationVariables,
  Country,
  RankingReportFilterInput,
  CursorPaginationReportInput,
  CreateZipWithSelectedRankingReportMutation,
  CreateZipWithSelectedRankingReportMutationVariables,
  GenerateTargetReportRequestMutation,
  GenerateTargetReportRequestMutationVariables,
} from '../../types'
import { RANKING_REPORT_BY_COUNTRY_AND_FILTERS } from './Queries'
import { FetchResult } from '@apollo/client'

export const generateTargetReportRequest = async (
  companyId: string,
  country: Country,
): Promise<FetchResult<GenerateTargetReportRequestMutation>> => {
  return client.mutate<GenerateTargetReportRequestMutation, GenerateTargetReportRequestMutationVariables>({
    mutation: GENERATE_TARGET_REPORT_REQUEST,
    variables: { companyId, country },
  })
}

// The refetchQueries is not used because it is executed in the background after the mutation,
// so the await only waits for the mutation and not for the refetch of the query.
export const generateRankingReport = async (
  reportId: string,
  countries: Country[],
  filters: RankingReportFilterInput,
  pagination: CursorPaginationReportInput,
): Promise<FetchResult<GenerateRankingReportMutation>> => {
  const mutationResult = await client.mutate<GenerateRankingReportMutation, GenerateRankingReportMutationVariables>({
    mutation: GENERATE_RANKING_REPORT,
    variables: { reportId },
  })

  await client.query({
    query: RANKING_REPORT_BY_COUNTRY_AND_FILTERS,
    variables: {
      countries,
      filters,
      pagination,
    },
    fetchPolicy: 'network-only',
  })

  return mutationResult
}

export const createZipWithSelectedRankingReports = async (
  reportIds: string[],
): Promise<FetchResult<CreateZipWithSelectedRankingReportMutation>> => {
  return client.mutate<CreateZipWithSelectedRankingReportMutation, CreateZipWithSelectedRankingReportMutationVariables>({
    mutation: CREATE_ZIP_WITH_SELECTED_RANKING_REPORTS,
    variables: { reportIds },
  })
}
